module.exports = __webpack_public_path__ + "img/9788992036955.ed9c95cd.jpg";